import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import { useSalonContext } from '@customer/components/pages/Salon/context'
import { route } from '@helpers'
import { ReactComponent as DownloadIcon } from '@icons/download.svg'
import { ReactComponent as TextIcon } from '@icons/text.svg'
import { ReactComponent as GalleryIcon } from '@icons/gallery.svg'
import React from 'react'
import CertificateDownload from './components/CertificateDownload'
import useSalonFileController from '@customer/api/useSalonFileController'
import useSalonController from '@general/api/useSalonController'

export default function SalonFinishedActions() {
    const { salon } = useSalonContext()
    const controller = useSalonFileController(salon.state.id)
    const GeneralSalonController = useSalonController()
    const ebook = () => GeneralSalonController.ebook(salon.state.slug)

    return (
        <Flex gap="7px" flexWrap="wrap">
            <CertificateDownload />
            <Button type="tertiary" icon={<DownloadIcon />} to={controller.report} element="a">Report Card</Button>
            {salon.state.ebook && <Button type="tertiary" icon={<DownloadIcon />} onClick={ebook}>Ebook</Button>}
            <Button type="tertiary" icon={<GalleryIcon />} href={route("general:salon:gallery", salon.state.slug)} target="_blank" element="a">Gallery</Button>
            <Button type="tertiary" icon={<TextIcon />} href={route("general:salon:acceptances", salon.state.slug)} target="_blank" element="a">Acceptances List</Button>
        </Flex>
    )
}